import type { GetAvailabilityQuery, GetAvailabilitySummaryQuery } from '@/types/api';

export const availabilityKeys = {
  all: ['availability'] as const,
  list: (params?: GetAvailabilityQuery) =>
    [...availabilityKeys.all, 'list', params] as const,
  summary: (params?: GetAvailabilitySummaryQuery) =>
    [...availabilityKeys.all, 'summary', params] as const,
};
